"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Placeholder = function Placeholder(_ref) {
  var innerProps = _ref.innerProps,
      children = _ref.children;
  return _react2.default.createElement("span", _extends({
    className: "c-muted-2"
  }, innerProps), children);
};

Placeholder.propTypes = {
  innerProps: _propTypes2.default.object,
  children: _propTypes2.default.node.isRequired
};
exports.default = Placeholder;